<div
  class="loggregationCellContainer"
  (mouseover)="mouseOver($event)"
  (click)="onCellClicked($event)"
  (mouseout)="OnMouseOut($event)"
  [innerHTML]="paramsValue"
></div>
